export const getApiArticlesList =
  "https://www.24-crm.tn/webservice/api/ARTICLEs";
export const getApiClientList = "https://www.24-crm.tn/webservice/api/CLIENTs";
export const getApiFournisseurList =
  "https://www.24-crm.tn/webservice/api/FOURNISSEURs";
export const deleteApiClient = "https://www.24-crm.tn/webservice/api/CLIENTs/";
